import { IActivity } from 'app/shared/model/activity.model';

export interface IActivityNote {
  id?: number;
  itemDetails?: string | null;
  activity?: IActivity | null;
}

export const defaultValue: Readonly<IActivityNote> = {};
